<a
  *ngIf="!menuItem!.href"
  (click)="slideMenuService.showed = false"
  [routerLink]="menuItem!.link"
  [ngClass]="[colorClass, menuItem!.class]"
  class="btn btn-link text-decoration-none fw-500 letter-spacing-10">
  <b>{{ menuItem!.title }}</b>
</a>

<a
  *ngIf="menuItem!.href"
  (click)="slideMenuService.showed = false"
  href="{{menuItem!.link}}"
  [ngClass]="[colorClass, menuItem!.class]"
  class="btn btn-link text-decoration-none fw-500 letter-spacing-10">
  <b>{{ menuItem!.title }}</b>
</a>